module.exports = __webpack_public_path__ + "static/media/flatbread-function-vector.b3fea012.svg";